// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as OrderStatus from "../../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as EventTracker from "../../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as OrderNavbarVm from "./vm-mapper/OrderNavbarVm.bs.js";
import * as Navbar$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as WorkSpaceContext from "../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as NLOrderModalManager from "./modals/NLOrderModalManager.bs.js";
import * as TicketsRequestMapper from "../../../../../ticket-dashboard/app/tickets/entitiy-mapper/TicketsRequestMapper.bs.js";
import * as CrmControlledReleaseHOC from "../../../../../../../library/data-source/controlled-rollout/component/CrmControlledReleaseHOC.bs.js";
import * as TertiaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/TertiaryButton.bs.js";
import * as CrmControlledReleaseContext from "../../../../../../../library/data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";

function getTicketingOrderData(order_details) {
  return order_details._0.order_invoice_url;
}

function getNavbarActions(order, tickets, workspaceDispatch, openModal, is_live, order_details, toggleEditOrderSidebar, adjust_fare_page_access_type, sms_details_page_access_type) {
  var status = order.status;
  var order_crn = order.order_crn;
  var tmp;
  switch (tickets.TAG | 0) {
    case /* Live */1 :
        tmp = List.length(tickets._0) !== 0;
        break;
    case /* Loading */0 :
    case /* Error */2 :
        tmp = false;
        break;
    
  }
  var match = process.env.INFRA_STACK;
  var tmp$1 = match === "india" ? false : true;
  return List.map((function (param) {
                return {
                        label: param.label,
                        on_select_cb: param.on_select_cb,
                        icon: param.icon
                      };
              }), List.filter(function (a) {
                    return a.is_visible;
                  })({
                  hd: {
                    label: {
                      TAG: /* Text */0,
                      _0: "Raise Ticket"
                    },
                    on_select_cb: (function (param) {
                        return Curry._2(workspaceDispatch.addTab, {
                                    TAG: /* RaiseTicket */14,
                                    _0: order_crn
                                  }, false);
                      }),
                    icon: undefined,
                    is_visible: is_live
                  },
                  tl: {
                    hd: {
                      label: {
                        TAG: /* Text */0,
                        _0: "Adjust Fare"
                      },
                      on_select_cb: (function (param) {
                          EventTracker.publishEvent({
                                category: "Adjust Fare",
                                action: "New Adjust Fare button clicked",
                                label: "Random",
                                value: undefined,
                                nonInteraction: undefined
                              });
                          return Curry._2(workspaceDispatch.addTab, {
                                      TAG: /* NewAdjustFare */12,
                                      _0: order_crn
                                    }, false);
                        }),
                      icon: undefined,
                      is_visible: status === 7 || status === 6
                    },
                    tl: {
                      hd: {
                        label: {
                          TAG: /* Text */0,
                          _0: "Edit Order"
                        },
                        on_select_cb: (function (param) {
                            EventTracker.publishEvent({
                                  category: "Edit Order GA4",
                                  action: "New Edit Order button clicked",
                                  label: "Random",
                                  value: undefined,
                                  nonInteraction: undefined
                                });
                            return Curry._1(toggleEditOrderSidebar, undefined);
                          }),
                        icon: undefined,
                        is_visible: true
                      },
                      tl: {
                        hd: {
                          label: {
                            TAG: /* Text */0,
                            _0: "Order Logs"
                          },
                          on_select_cb: (function (param) {
                              return Curry._2(workspaceDispatch.addTab, {
                                          TAG: /* OrderLogs */13,
                                          _0: order_crn
                                        }, false);
                            }),
                          icon: undefined,
                          is_visible: true
                        },
                        tl: {
                          hd: {
                            label: {
                              TAG: /* Text */0,
                              _0: "View Tickets"
                            },
                            on_select_cb: (function (param) {
                                return Curry._2(workspaceDispatch.addTab, {
                                            TAG: /* Tickets */42,
                                            _0: TicketsRequestMapper.DictEncoder.execute({
                                                  crn: order_crn,
                                                  case_number: undefined,
                                                  caller_number: undefined,
                                                  msisdn: undefined,
                                                  start_datetime: undefined,
                                                  end_datetime: undefined,
                                                  ticket_status: undefined,
                                                  geo_region: undefined,
                                                  raised_by: undefined
                                                })
                                          }, false);
                              }),
                            icon: undefined,
                            is_visible: tmp
                          },
                          tl: {
                            hd: {
                              label: {
                                TAG: /* Text */0,
                                _0: "Send Invoice"
                              },
                              on_select_cb: (function (param) {
                                  return Curry._2(workspaceDispatch.addTab, {
                                              TAG: /* SendInvoice */27,
                                              _0: order_crn
                                            }, false);
                                }),
                              icon: undefined,
                              is_visible: status >= 6
                            },
                            tl: {
                              hd: {
                                label: {
                                  TAG: /* Text */0,
                                  _0: "Get Order Fare Details"
                                },
                                on_select_cb: (function (param) {
                                    return Curry._2(workspaceDispatch.addTab, {
                                                TAG: /* OrderFare */11,
                                                order_crn: order_crn
                                              }, false);
                                  }),
                                icon: undefined,
                                is_visible: true
                              },
                              tl: {
                                hd: {
                                  label: {
                                    TAG: /* Text */0,
                                    _0: "SMS Details"
                                  },
                                  on_select_cb: (function (param) {
                                      if (sms_details_page_access_type !== 1) {
                                        return Curry._2(workspaceDispatch.addTab, /* SendSMS */2, false);
                                      } else {
                                        return Curry._2(workspaceDispatch.addTab, {
                                                    TAG: /* SMSDetails */30,
                                                    _0: order_crn
                                                  }, false);
                                      }
                                    }),
                                  icon: undefined,
                                  is_visible: true
                                },
                                tl: {
                                  hd: {
                                    label: {
                                      TAG: /* Text */0,
                                      _0: "Create Penalty"
                                    },
                                    on_select_cb: (function (param) {
                                        var partner_info = order.partner;
                                        return Curry._2(workspaceDispatch.addTab, {
                                                    TAG: /* CreatePenalty */26,
                                                    orderId: order_crn,
                                                    msisdn: partner_info !== undefined ? partner_info.id : undefined
                                                  }, false);
                                      }),
                                    icon: undefined,
                                    is_visible: true
                                  },
                                  tl: {
                                    hd: {
                                      label: {
                                        TAG: /* Text */0,
                                        _0: "Instamojo Payment Links"
                                      },
                                      on_select_cb: (function (param) {
                                          return Curry._1(openModal, /* InstaMojo */{
                                                      order_id: order_crn
                                                    });
                                        }),
                                      icon: undefined,
                                      is_visible: status === 7 || status === 6
                                    },
                                    tl: {
                                      hd: {
                                        label: {
                                          TAG: /* Text */0,
                                          _0: "Give Goodwill Partner Bonus"
                                        },
                                        on_select_cb: (function (param) {
                                            var order;
                                            var acceptedOrder;
                                            var exit = 0;
                                            switch (order_details.TAG | 0) {
                                              case /* Open */0 :
                                                  return ;
                                              case /* Accepted */1 :
                                              case /* Live */2 :
                                              case /* Ended */3 :
                                                  exit = 2;
                                                  break;
                                              case /* Cancelled */4 :
                                                  var data = order_details._1.partner_info;
                                                  return Curry._2(workspaceDispatch.addTab, {
                                                              TAG: /* GiveGoodwillPartnerBonus */32,
                                                              crn: order_details._0.order_crn,
                                                              msisdn: data !== undefined ? data.msisdn : ""
                                                            }, false);
                                              default:
                                                order = order_details._0;
                                                acceptedOrder = order_details._2;
                                            }
                                            if (exit === 2) {
                                              order = order_details._0;
                                              acceptedOrder = order_details._1;
                                            }
                                            return Curry._2(workspaceDispatch.addTab, {
                                                        TAG: /* GiveGoodwillPartnerBonus */32,
                                                        crn: order.order_crn,
                                                        msisdn: acceptedOrder.partner_info.msisdn
                                                      }, false);
                                          }),
                                        icon: undefined,
                                        is_visible: true
                                      },
                                      tl: {
                                        hd: {
                                          label: {
                                            TAG: /* Text */0,
                                            _0: "Old Order Detail"
                                          },
                                          on_select_cb: (function (param) {
                                              return Curry._2(workspaceDispatch.addTab, {
                                                          TAG: /* OrderDetail */9,
                                                          _0: order_crn
                                                        }, false);
                                            }),
                                          icon: undefined,
                                          is_visible: true
                                        },
                                        tl: {
                                          hd: {
                                            label: {
                                              TAG: /* Text */0,
                                              _0: "View City Toll Routes"
                                            },
                                            on_select_cb: (function (param) {
                                                var order = order_details._0;
                                                return Curry._2(workspaceDispatch.addTab, {
                                                            TAG: /* ViewCityTollRoutes */31,
                                                            _0: String(order.geo_region_id),
                                                            _1: String(order.vehicle.vehicle_id)
                                                          }, false);
                                              }),
                                            icon: undefined,
                                            is_visible: true
                                          },
                                          tl: {
                                            hd: {
                                              label: {
                                                TAG: /* Text */0,
                                                _0: "Old Edit Order"
                                              },
                                              on_select_cb: (function (param) {
                                                  EventTracker.publishEvent({
                                                        category: "Edit Order GA4",
                                                        action: "Old Edit Order button clicked",
                                                        label: "Random",
                                                        value: undefined,
                                                        nonInteraction: undefined
                                                      });
                                                  return Curry._2(workspaceDispatch.addTab, {
                                                              TAG: /* EditOrder */25,
                                                              _0: order_crn
                                                            }, false);
                                                }),
                                              icon: undefined,
                                              is_visible: tmp$1
                                            },
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

function OrderNavbar(Props) {
  var order_details = Props.order_details;
  var tickets = Props.tickets;
  var is_live = Props.is_live;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var order = OrderNavbarVm.getVm(order_details);
  var match = NLOrderModalManager.useModal(undefined);
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var adminBetaPageAccessData = React.useContext(CrmControlledReleaseContext.context);
  CrmControlledReleaseHOC.getAccessType(adminBetaPageAccessData.adminBetaAccessData.page_config, "edit_order");
  var adjust_fare_page_access_type = CrmControlledReleaseHOC.getAccessType(adminBetaPageAccessData.adminBetaAccessData.page_config, "adjust_fare");
  var sms_details_page_access_type = CrmControlledReleaseHOC.getAccessType(adminBetaPageAccessData.adminBetaAccessData.page_config, "send_sms");
  var partner = order.partner;
  return React.createElement(React.Fragment, undefined, React.createElement(Navbar$Catalyst.make, {
                  title: "Order Details",
                  navbar_item_first: {
                    label: "Order",
                    value: {
                      TAG: /* Text */0,
                      _0: order.order_crn
                    }
                  },
                  navbar_item_second: {
                    label: "Status",
                    value: {
                      TAG: /* Text */0,
                      _0: $$String.capitalize_ascii(OrderStatus.toString(order.status))
                    }
                  },
                  navbar_item_third: {
                    label: "Customer",
                    value: {
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement(TertiaryButton$Catalyst.make, {
                                      onSelectCB: (function (param) {
                                          return Curry._2(workspaceDispatch.addTab, {
                                                      TAG: /* CustomerProfile */35,
                                                      _0: String(order.customer.id)
                                                    }, false);
                                        }),
                                      children: order.customer.name
                                    });
                        })
                    }
                  },
                  navbar_item_fourth: partner !== undefined ? ({
                        label: "Partner",
                        value: {
                          TAG: /* Custom */1,
                          _0: (function (param) {
                              return React.createElement(TertiaryButton$Catalyst.make, {
                                          onSelectCB: (function (param) {
                                              return Curry._2(workspaceDispatch.addTab, {
                                                          TAG: /* DriverDashboardV2 */5,
                                                          _0: partner.id
                                                        }, false);
                                            }),
                                          children: partner.name
                                        });
                            })
                        }
                      }) : ({
                        label: "",
                        value: {
                          TAG: /* Text */0,
                          _0: ""
                        }
                      }),
                  actions: getNavbarActions(order, tickets, workspaceDispatch, match[1], is_live, order_details, toggleEditOrderSidebar, adjust_fare_page_access_type, sms_details_page_access_type),
                  visible_actions_limit: 3
                }), match[0]);
}

var make = OrderNavbar;

export {
  getTicketingOrderData ,
  getNavbarActions ,
  make ,
  
}
/* react Not a pure module */
